var render = function () {
var this$1 = this;
var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-text-field',{attrs:{"clearable":"","id":"buscador","label":_vm.$t('Buscar'),"solo":""},on:{"click:clear":function (){this$1.text = ' '; this$1.$emit('search', ' ')}},model:{value:(_vm.text),callback:function ($$v) {_vm.text=$$v},expression:"text"}})}
var staticRenderFns = []

export { render, staticRenderFns }